import {
  AccountBalance,
  Category,
  Close,
  Info,
  LiveHelp,
  Menu,
  MiscellaneousServices,
  PsychologyAltSharp,
  Recommend,
  RequestQuote,
  School,
  ShoppingCart,
} from "@mui/icons-material";
import GavelIcon from "@mui/icons-material/Gavel";
import InfoIcon from "@mui/icons-material/Info";
import PhoneLockedIcon from "@mui/icons-material/PhoneLocked";
import {
  Badge,
  Button,
  IconButton,
  Stack,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { FC, Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import AnimateButton from "../../../components/@extended/AnimateButton";
import MouseOverPopover from "../../../components/MouseOverPopOver/MouseOverPopOver";
import MouseOverPopOverMobile2 from "../../../components/MouseOverPopOverMobile2/MouseOverPopOverMobile2";
import {
  CUSTOMER,
  DIAMOND,
  GOLD,
  PLATINUM,
  SILVER,
} from "../../../config/constants";
import {
  userIsAuthenticated,
  userIsAWorker,
} from "../../../stateManagement/helpers";
import {
  IAuthState,
  IUser,
  tryLogout,
} from "../../../stateManagement/reducers/authReducer";
import { ICartState } from "../../../stateManagement/reducers/cartReducer";
import {
  IMenuState,
  setGlobalNavItems,
  setMainNavItem,
} from "../../../stateManagement/reducers/menuReducer";
import { IOrdersState } from "../../../stateManagement/reducers/ordersReducer";
import { setMainRentalItem } from "../../../stateManagement/reducers/rentalItemsReducer";
import { IRoutesState } from "../../../stateManagement/reducers/routesReducer";
import { IRootReducerT } from "../../../stateManagement/reduxStore";
import navItems, {
  diamondNavItems,
  goldNavItems,
  platnumNavItems,
  silverNavItems,
} from "./navItems";
import Profile from "./Profile";

function getNavIcon(navTitle: string, selected = false) {
  switch (navTitle) {
    case "Home":
      return (
        <AccountBalance color={selected ? "info" : ("white" as "primary")} />
      );
    case "About Us":
      return <Info color={selected ? "info" : ("white" as "primary")} />;
    case "Testimonials":
      return <Recommend color={selected ? "info" : ("white" as "primary")} />;
    case "Services":
      return (
        <MiscellaneousServices
          color={selected ? "info" : ("white" as "primary")}
        />
      );
    case "Memberships":
      return (
        <RequestQuote color={selected ? "info" : ("white" as "primary")} />
      );
    case "RESOURCE HUB":
    case "Resources":
      return <Category color={selected ? "info" : ("white" as "primary")} />;
    case "FAQ":
      return <LiveHelp color={selected ? "info" : ("white" as "primary")} />;
    case "Practice Areas":
      return <GavelIcon color={selected ? "info" : ("white" as "primary")} />;
    case "About":
      return <InfoIcon color={selected ? "info" : ("white" as "primary")} />;
    case "Contact":
      return <PhoneLockedIcon />;
    case "LMS":
      return <School color={selected ? "info" : ("white" as "primary")} />;
    case "HELP":
      return (
        <PsychologyAltSharp
          color={selected ? "info" : ("white" as "primary")}
        />
      );
    default:
      return null;
  }
}

interface IMobileNavProps2 {
  setPresentPage: (page: string) => void;
}

const MobileNavigation2: FC<IMobileNavProps2> = ({ setPresentPage }) => {
  const location = useLocation();

  const [pathname, setPathname] = useState(location.pathname);

  const { user, authToken } = useSelector<IRootReducerT, IAuthState>(
    (state) => state.auth,
  );
  const { globalNavItems } = useSelector<IRootReducerT, IMenuState>(
    (state) => state.menu,
  );

  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const theme = useTheme();
  const idGreaterThanMd = useMediaQuery(theme.breakpoints.up("md"));

  const title = process.env.REACT_APP_APP_NAME;

  const k = 1;
  // const drawerWidth = 240;
  const drawerWidth = "100%";

  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const [lNavItems, setLNavItems] = useState(
    globalNavItems.length > 0 ? globalNavItems : navItems,
  );

  const updateNavItems = () => {
    if (
      user &&
      userIsAuthenticated(user as IUser) &&
      user?.role?.name === CUSTOMER
    ) {
      const membershipType = SILVER;

      switch (membershipType) {
        case SILVER:
        default:
          setLNavItems(silverNavItems);
          dispatch(setGlobalNavItems(silverNavItems));
          break;
      }
    } else {
      setLNavItems(navItems);
    }
  };

  useEffect(() => {
    setPathname(location?.pathname);
  }, [location]);

  useEffect(() => {
    updateNavItems();
  }, [user, authToken]);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <div className="text-left p-[1rem] tracking-[.18em] text-[#2c3335cc] x-[.875rem] leading-[1.25rem] font-[Inter]">
      <ul className="h-full">
        {lNavItems.map((page, index) => (
          <li key={`${index}${k}`} className="p-0">
            <div
              className="flex flex-row items-center justify-start w-full mx-auto"
              style={{
                color: pathname === page.url ? "success" : "black",
              }}
            >
              <MouseOverPopOverMobile2
                baseUri={page.id}
                url={page.url}
                title={page.title}
                navItems={page.children}
                callback={() => {
                  setMobileOpen(false);
                  dispatch(setMainNavItem(page));
                }}
              />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <>
      {!idGreaterThanMd && user && userIsAuthenticated(user as IUser) && (
        <Profile />
      )}
      <div className="flex justify-center mr-0  md:hidden lg:hidden">
        <button
          className="text-black bg-transparent"
          onClick={handleDrawerToggle}
          aria-label="open drawer"
        >
          {!mobileOpen && (
            <Menu
              fontSize="medium"
              style={{ color: theme.palette.background.default }}
            />
          )}
          {mobileOpen && (
            <Close
              fontSize="medium"
              style={{ color: theme.palette.background.default }}
            />
          )}
        </button>
      </div>
      <nav>
        {mobileOpen && (
          <div
            className="fixed inset-0  z-50"
            onClick={handleDrawerToggle}
          ></div>
        )}
        <Stack
          sx={{ width: "100%", px: "1rem" }}
          className={`${
            mobileOpen
              ? "translate-x-0  opacity-1"
              : "translate-x-full opacity-0"
          }  fixed top-[5rem] right-0 h-full w-full z-[100000000] transition-opacity duration-300  ease-in-out`}
        >
          <div
            className={`h-[fit-content] w-full bg-[#faf9f6b8] backdrop-blur-[14px]  transform overflow-y-auto pt-6 pb-20 md:block lg:hidden`}
          >
            {drawer}
            <div className="flex flex-col items-center w-full px-28 pt-4 text-xs space-y-4">
              {(!user || (user && !userIsAuthenticated(user as IUser))) && (
                <>
                  <AnimateButton>
                    <Button
                      variant="outlined"
                      sx={{
                        boxShadow: theme.shadows[5],
                      }}
                      onClick={() => {
                        navigate("/login", { replace: true });
                        handleDrawerToggle();
                      }}
                    >
                      <b>LOGIN</b>
                    </Button>
                  </AnimateButton>
                  <AnimateButton>
                    <Button
                      variant="contained"
                      sx={{
                        boxShadow: theme.shadows[5],
                      }}
                      onClick={() => {
                        navigate("/sign-up", { replace: true });
                        handleDrawerToggle();
                      }}
                    >
                      <b>SIGN UP</b>
                    </Button>
                  </AnimateButton>
                </>
              )}
              {user && userIsAuthenticated(user as IUser) && (
                <>
                  <AnimateButton>
                    <Button
                      variant="contained"
                      size="large"
                      sx={{
                        backgroundColor: "#D4A84B",
                        border: "solid #D4A84B 1px",
                        my: 2,
                        boxShadow: theme.shadows[5],
                        px: "2rem !important",
                        color: "white",
                        "&:hover": {
                          borderColor: "white !important",
                          border: "solid white 1px",
                        },
                      }}
                      onClick={() => {
                        dispatch(tryLogout({ authToken: authToken ?? "" }));
                      }}
                    >
                      <b>LOG OUT</b>
                    </Button>
                  </AnimateButton>
                </>
              )}
            </div>
          </div>
        </Stack>
      </nav>
    </>
  );
};

interface INavProps {
  setShowCartModal: (truth: boolean) => void;
}

const Nav = ({ setShowCartModal }: INavProps) => {
  const dispatch = useDispatch<any>();

  const { presentRoute } = useSelector<IRootReducerT, IRoutesState>(
    (state) => state.routes,
  );
  const { user, authToken } = useSelector<IRootReducerT, IAuthState>(
    (state) => state.auth,
  );
  const { activeMembership } = useSelector<IRootReducerT, IOrdersState>(
    (state) => state.orders,
  );
  const { globalNavItems } = useSelector<IRootReducerT, IMenuState>(
    (state) => state.menu,
  );
  const location = useLocation();
  const [presentPage, setPresentPage] = useState("");
  const navigate = useNavigate();

  const theme = useTheme();
  const idGreaterThanMd = useMediaQuery(theme.breakpoints.up("md"));

  const [isInitRender, setIsInitRender] = useState(true);
  useEffect(() => {
    if (isInitRender) {
      setPresentPage(location.pathname);
      setIsInitRender(false);
      return;
    }

    if (presentPage !== "") {
      setPresentPage(presentRoute);
    }
  }, [presentPage]);

  const [lNavItems, setLNavItems] = useState(
    globalNavItems.length > 0 ? globalNavItems : navItems,
  );

  const { cart } = useSelector<IRootReducerT, ICartState>(
    (state) => state.cart,
  );

  const updateNavItems = () => {
    if (
      user &&
      userIsAuthenticated(user as IUser) &&
      user?.role?.name === CUSTOMER
    ) {
      const membershipType = activeMembership?.rentalPackage?.rentalItems
        ? (activeMembership?.rentalPackage?.rentalItems)[0].name
        : "";

      switch (membershipType) {
        case DIAMOND:
          setLNavItems(diamondNavItems);
          dispatch(setGlobalNavItems(diamondNavItems));
          break;
        case PLATINUM:
          setLNavItems(platnumNavItems);
          dispatch(setGlobalNavItems(platnumNavItems));
          break;
        case GOLD:
          setLNavItems(goldNavItems);
          dispatch(setGlobalNavItems(goldNavItems));
          break;
        case SILVER:
        default:
          setLNavItems(silverNavItems);
          dispatch(setGlobalNavItems(silverNavItems));
          break;
      }
    } else {
      setLNavItems(navItems);
    }
  };

  useEffect(() => {
    updateNavItems();
  }, [user, authToken]);

  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent={idGreaterThanMd ? "space-between" : "flex-end"}
        id="demo-customized-button"
        sx={{
          width: { xs: "fit-content", md: "100%" },
          marginLeft: "auto !important",
          marginRight: "auto !important",
          display: { xs: "flex", md: "flex", lg: "flex" },
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          sx={{
            flex: "1",
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            id="demo-customized-button"
            spacing={4}
            sx={{
              width: "fit-content",
              display: { xs: "none", md: "none", lg: "flex" },
            }}
          >
            {lNavItems.map((page, index) => {
              return (
                <Fragment key={index}>
                  <MouseOverPopover
                    baseUri={page.id}
                    url={page.url}
                    title={page.title}
                    navItems={page.children}
                    callback={() => {
                      dispatch(setMainNavItem(page));
                      dispatch(setMainRentalItem(null));
                    }}
                  />
                </Fragment>
              );
            })}
          </Stack>
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          id="demo-customized-button"
          spacing={4}
          sx={{
            width: "fit-content",
            height: "fit-content !important",
          }}
        >
          {user &&
            userIsAuthenticated(user as IUser) &&
            user.role?.name === CUSTOMER && (
              <AnimateButton>
                <IconButton onClick={() => setShowCartModal(true)}>
                  <Badge
                    overlap="circular"
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    badgeContent={cart.items.length}
                    color="error"
                    sx={{
                      "& *": { fontFamily: "Inter !important" },
                    }}
                  >
                    <ShoppingCart
                      sx={{ color: theme.palette.background.default }}
                    />
                  </Badge>
                </IconButton>
              </AnimateButton>
            )}
          {user &&
            userIsAuthenticated(user as IUser) &&
            userIsAWorker(user) && (
              <Stack
                direction="row"
                spacing="2rem"
                sx={{
                  height: "fit-content",
                  display: { xs: "none", md: "flex" },
                }}
              >
                <AnimateButton>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "success",
                      my: 2,
                      color: "white",
                      width: "fit-content !important",
                      fontSize: { xs: ".75rem", md: ".85rem", lg: "1rem" },
                      height: "fit-content !important",
                      py: {
                        xs: ".5rem !important",
                        md: ".75rem !important",
                        lg: "1.5rem",
                      },
                      px: {
                        xs: ".75rem !important",
                        md: "1.5rem !important",
                        lg: "2rem",
                      },
                    }}
                    onClick={() => {
                      navigate("/dashboard", { replace: true });
                    }}
                  >
                    {user?.role?.name?.toUpperCase()} DASHBOARD
                  </Button>
                </AnimateButton>
              </Stack>
            )}
          {(!user || (user && !userIsAuthenticated(user as IUser))) &&
            idGreaterThanMd && (
              <Stack
                direction="row"
                spacing="1rem"
                alignItems="center"
                sx={{
                  marginLeft: "0 !important",
                }}
              >
                <AnimateButton>
                  <Button
                    variant="outlined"
                    sx={{
                      fontSize: ".78rem",
                      my: ".5rem",
                      py: {
                        xs: ".5rem !important",
                        md: ".5rem !important",
                        lg: "1rem",
                      },
                      px: {
                        xs: ".5rem !important",
                        md: ".75rem !important",
                        lg: "1rem",
                      },
                      borderColor: theme.palette.background.default,
                      color: theme.palette.background.default,
                    }}
                    onClick={() => {
                      navigate("/login", { replace: true });
                    }}
                  >
                    LOGIN
                  </Button>
                </AnimateButton>
                <AnimateButton>
                  <Button
                    variant="contained"
                    sx={{
                      my: ".5rem",
                      color: "white",
                      fontSize: ".78rem",
                      py: {
                        xs: ".5rem !important",
                        md: ".5rem !important",
                      },
                      px: {
                        xs: ".5rem !important",
                        md: ".75rem !important",
                        lg: "1rem",
                      },
                    }}
                    onClick={() => {
                      navigate("/sign-up", { replace: true });
                    }}
                  >
                    SIGN UP
                  </Button>
                </AnimateButton>
              </Stack>
            )}
          {user && userIsAuthenticated(user as IUser) && idGreaterThanMd && (
            <Profile />
          )}
        </Stack>
        {!idGreaterThanMd && (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-around"
            spacing={1}
            sx={{
              width: "fit-content",
              p: "0",
              px: "1rem",
            }}
          >
            <MobileNavigation2 setPresentPage={setPresentPage} />
          </Stack>
        )}
      </Stack>
    </>
  );
};

export default Nav;
